import React from 'react'
import Layout from './components/Layout'
import { PageContextProvider } from './components/global/hooks/usePageContext';
import i18n from './i18n/config';
import { I18nextProvider } from 'react-i18next';

/**
 * Wrap all pages with a Translation provider, and set the language on SSR time.
 * PostHog is loaded by its snippet (gatsby-ssr.js), not here.
 */
export const wrapRootElement = ({ element }) => {
  return (
    <I18nextProvider i18n={i18n}>
      {element}
    </I18nextProvider>
  )
};

/**
 * Wrap all pages with a Layout and PageContext provider
 */
export const wrapPageElement = ({ element, props }) => {
  return (
    <PageContextProvider pageContext={props.pageContext}>
      <Layout {...props}>{element}</Layout>
    </PageContextProvider>
  )
};
